export const getAuthUser = state => state.app.auth.user;
